import { setSessionItem } from "./sessionStorage";

const isLocalHost = () => {
	return window.location.hostname.indexOf('localhost') > -1 ? true : false
}

/*
  Return the Top Pics product information from galleryInfo.jsp or []
*/
const getTopPicksInfo = (topPicks) => {	
    let topPickItems = '';
    let returnedData = [];	
    if (isLocalHost()) {
		window.bf20.previewMode ? 
			returnedData = window.bf20.galleryInfoDataPreview :
			returnedData = window.bf20.galleryInfoData		
			if (window.bf20.hasStorage) {
				setSessionItem(returnedData);
			}
			if (shopdirect && shopdirect.event) {
				shopdirect.event.publish('bf-home/top-picks', {
					'productData': returnedData
				});
			}
    } else {
		/*
			Iterate through the Top Picks array and add each productID to topPickItems String to be using for galleryInfo URL
		*/
		topPicks.forEach((item,i) => { 
			topPickItems = topPickItems + item;
			if (i < topPicks.length - 1) {
				topPickItems = topPickItems + ',';
			}
		});
			
		const link = `/json/galleryInfo.jsp?sdgProductId=${topPickItems}`;
		$sd.ajax({          
			dataType: "jsonp",
			url: link,
			data: {},
			jsonp: "cb",
			jsonpCallback: "callback"
		}).done(function(data) {
			if (data.productData) {                
				if (shopdirect && shopdirect.event) {					
					if (window.bf20.hasStorage) {
						setSessionItem(data.productData);
					}
					shopdirect.event.publish('bf-home/top-picks', {
						'productData': data.productData
					});
				}       
			}
		}).fail(function(jqXHR, textStatus, errorThrown) { 
			console.log('jqXHR, textStatus, errorThrown', jqXHR, textStatus, errorThrown);
			return [];
		});		
	}
};
  
export default getTopPicksInfo;